import { fetchQuery_DEPRECATED as fetchQuery } from 'react-relay/legacy';
import { getBuyerId } from 'dibs-cookie-jar';

import { privacyPolicyChangeNoticeAction } from './privacyPolicyChangeNoticeAction';
import { privacyPolicyChangeNoticeQuery } from './privacyPolicyChangeNoticeQuery';

import { blockedPageTypes, initialRule, viewerRule } from './privacyPolicyChangeNoticeHelpers';

import { hasUserSessionCountryCode } from 'dibs-regional-info/exports/regionalInfoHelpers';

export const privacyPolicyChangeNoticeRule = ({ relayEnvironment }) => {
    const userId = getBuyerId(document.cookie);

    if (!initialRule(userId)) {
        return Promise.resolve(false);
    }

    return fetchQuery(relayEnvironment, privacyPolicyChangeNoticeQuery, {
        userId,
        hasSessionCountryCode: hasUserSessionCountryCode(),
    }).then(response => Promise.resolve(viewerRule(response && response.viewer)));
};

export const privacyPolicyChangeNoticeConfig = {
    name: 'privacyPolicyChangeNotice',
    rule: privacyPolicyChangeNoticeRule,
    blockedPageTypes,
    action: privacyPolicyChangeNoticeAction,
    priority: 1,
};
